























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Validation } from 'vuelidate';

@Component
export default class Field extends Vue {
  @Prop() readonly value!: string
  @Prop() readonly validation!: Validation
  @Prop({ default: 'Field' }) readonly label!: string
  @Prop({ default: 'text' }) readonly type!: string
  @Prop({ default: '' }) readonly placeholder!: string

  get fieldName(): string {
    return `field-${this.type}-${this.label.toLowerCase()}`;
  }

  get fieldType(): string {
    return `field-${this.type}`;
  }

  get invalidWarning(): string {
    return this.validation.$invalid ? 'invalid-warning': ''
  }

  get invalidError(): string {
    return this.validation.$dirty && this.validation.$invalid? 'invalid-error': ''
  }

  @Emit('changed')
  changed() {
    return this.validation.$model;
  }
}
